/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/*jslint white: true */
/*jslint node: true */
/*global jQuery, jQuery, Swiper, ScrollMagic*/

// slider acf
if ( objects.is_front_page || objects.is_front_section ) {
	// slider acf
	var swiper_acf = new Swiper('.swiper-acf', {
		spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
		pagination: {
			el: '#accueil .swiper-pagination',
			clickable: true
		},
		autoplay: {
			delay: 4000,
		}
	});


	// slider acf 2
	var swiper_acf_2 = new Swiper('.swiper-acf-2', {
		spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
	});

	// slider acf 3
	var swiper_acf_3 = new Swiper('.swiper-acf-3', {
		spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
	});

	swiper_acf.controller.control = swiper_acf_2;
	swiper_acf_2.controller.control = swiper_acf_3;
	swiper_acf_3.controller.control = swiper_acf_2;
};

if ( objects.is_page_histoire ) {
	// slider acf
	var swiper_acf = new Swiper('.swiper-acf', {
		spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
		pagination: {
			el: '#accueil .swiper-pagination',
			clickable: true,
		},
		autoplay: {
			delay: 4000,
		},
	});
}


var swiper_avis = new Swiper('.swiper-avis', {
	slidesPerView: 1,
	centeredSlides: true,
	spaceBetween: 30,
	pagination: {
		el: '.swiper-pagination',
		type: 'fraction',
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	autoplay: {
		delay: 14000,
	}
});